import React from "react";
import { Doughnut } from "react-chartjs-2";

const ChartDoughnut = ({ className, valueChart, chartColor, chartLabel, legend = true, datalabels = true, isCircSmall = false, showLabelCenter = false, children}) => {
    const chartData = valueChart;
    const bgColor = chartColor; //["#00C1D4", "#406882", "#EB5757"]
    const showData = chartData[0] + "%";
    const options1 = {
        responsive: true,
        plugins: {
            datalabels: {
                display: datalabels,
                formatter: (value) => {
                    return value + "%";
                },
                color: "#fff",
                font: {
                    size: 9,
                    weight: "bold",
                },
            },
            legend: {
                display: legend,
                position: "bottom",
                labels: {
                    fontSize: 14,
                    fontColor: "#6C757D",
                    fontFamily: "Calibri",
                },
            },
        },
    };

    const plugins = {
        id: "doughnut-plugin",
		afterDatasetDraw: (chart) => {
            const { ctx } = chart;
            if(showLabelCenter) { 
                const cx = chart.height;
                const cy = chart.width;
            
                ctx.restore();
                var fontSize = (cx / 114).toFixed(2);
                ctx.font = "bold " + fontSize + "em sans-serif";
                ctx.fillStyle = "#757575";
                ctx.textBaseline = "middle";
                
                var text = chartData[0];
                var ctext = text + "%" ;
                
                var textX = Math.round((cy - ctx.measureText(ctext).width) / 2);
                var textY = cx / 2;
                if(text) {
                    ctx.fillText(ctext, textX, textY);
                }
                ctx.save();
            }
          }
	};

    const data = {
        labels: chartLabel, // ["IPA", "IPS", "Bahasa"],
        datasets: [
            {
                data: chartData,
                backgroundColor: bgColor,
                cutout: isCircSmall ? "85%" : "50%",
            },
        ],
        text: showData,
    };

    return (
        <div className={className}>
            <Doughnut data={data} options={options1} plugins={isCircSmall ? [plugins] : []}/>
            {children}
        </div>
    );
};

export default ChartDoughnut;
